module.exports = __webpack_public_path__ + "img/swap-mid.5c38b8da.svg";